import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-md border-b border-background-200/70">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-16">
          <a
            href="/"
            className="flex items-center gap-2 text-foreground-900 hover:text-foreground-700 transition-colors duration-200"
          >
            <span className="text-xl font-bold tracking-tight font-heading">LRGS1</span>
          </a>

          <nav className="hidden md:flex items-center gap-8">
            <a
              href="/"
              className="text-sm font-medium tracking-wide transition-colors duration-200 whitespace-nowrap text-foreground-900"
            >
              HOME
            </a>
          </nav>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <nav className="flex flex-col px-4 py-4 gap-3">
            <a
              href="/"
              className="text-sm font-medium tracking-wide py-2 transition-colors duration-200 text-foreground-900"
            >
              HOME
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
